
import { Blog } from './blog.model';
import { Subject } from 'rxjs';


export class BlogService{
    blogChanged = new Subject<Blog[]>();
    blogID:number;

    
     
   private blogs: Blog[]; 
   users:string;


    constructor(){}
     
getBlogs(){
    return this.blogs.slice(); 
}

getBlogOfIndex(index:number){
    return this.blogs[index];
}

setBlog(blog:Blog[]){

    this.blogs = blog;
    this.blogChanged.next(this.blogs);
}

setUsername(user:string){
  
    this.users = user;
 }
    
    
    
    
}




